import styled, { keyframes } from 'styled-components';

const loadingAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const Container = styled.div`
  display: inline-block;
  width: 80px;
  height: 80px;
  align-self: center;
  margin-top: 50px;

  &:after {
    content: ' ';
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #0d47a1;
    border-color: #0d47a1 transparent #0d47a1 transparent;
    animation: ${loadingAnimation} 1.2s linear infinite;
  }
`;
